<template>
  <div class="header-personal">

    <div class="selected" @click="openSelector()">
      <img v-if="true" class="image" :src="currentCounterparty.image">
      <div class="name-dd">
        <span>{{currentCounterparty.title}}</span>
        <svg :class="[{active: showSelector}]" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M5.83325 8.33331L9.99992 11.6666L14.1666 8.33331" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <div v-show="showSelector" class="selector">
      <div class="nav_item" @click="toSettings('#individual_settings')">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M20.3175 6.14139L19.8239 5.28479C19.4506 4.63696 19.264 4.31305 18.9464 4.18388C18.6288 4.05472 18.2696 4.15664 17.5513 4.36048L16.3311 4.70418C15.8725 4.80994 15.3913 4.74994 14.9726 4.53479L14.6357 4.34042C14.2766 4.11043 14.0004 3.77133 13.8475 3.37274L13.5136 2.37536C13.294 1.71534 13.1842 1.38533 12.9228 1.19657C12.6615 1.00781 12.3143 1.00781 11.6199 1.00781H10.5051C9.81078 1.00781 9.4636 1.00781 9.20223 1.19657C8.94085 1.38533 8.83106 1.71534 8.61149 2.37536L8.27753 3.37274C8.12465 3.77133 7.84845 4.11043 7.48937 4.34042L7.15249 4.53479C6.73374 4.74994 6.25259 4.80994 5.79398 4.70418L4.57375 4.36048C3.85541 4.15664 3.49625 4.05472 3.17867 4.18388C2.86109 4.31305 2.67445 4.63696 2.30115 5.28479L1.80757 6.14139C1.45766 6.74864 1.2827 7.05227 1.31666 7.37549C1.35061 7.69871 1.58483 7.95918 2.05326 8.48012L3.0843 9.63282C3.3363 9.95185 3.51521 10.5078 3.51521 11.0077C3.51521 11.5078 3.33636 12.0636 3.08433 12.3827L2.05326 13.5354C1.58483 14.0564 1.35062 14.3168 1.31666 14.6401C1.2827 14.9633 1.45766 15.2669 1.80757 15.8741L2.30114 16.7307C2.67443 17.3785 2.86109 17.7025 3.17867 17.8316C3.49625 17.9608 3.85542 17.8589 4.57377 17.655L5.79394 17.3113C6.25263 17.2055 6.73387 17.2656 7.15267 17.4808L7.4895 17.6752C7.84851 17.9052 8.12464 18.2442 8.2775 18.6428L8.61149 19.6403C8.83106 20.3003 8.94085 20.6303 9.20223 20.8191C9.4636 21.0078 9.81078 21.0078 10.5051 21.0078H11.6199C12.3143 21.0078 12.6615 21.0078 12.9228 20.8191C13.1842 20.6303 13.294 20.3003 13.5136 19.6403L13.8476 18.6428C14.0004 18.2442 14.2765 17.9052 14.6356 17.6752L14.9724 17.4808C15.3912 17.2656 15.8724 17.2055 16.3311 17.3113L17.5513 17.655C18.2696 17.8589 18.6288 17.9608 18.9464 17.8316C19.264 17.7025 19.4506 17.3785 19.8239 16.7307L20.3175 15.8741C20.6674 15.2669 20.8423 14.9633 20.8084 14.6401C20.7744 14.3168 20.5402 14.0564 20.0718 13.5354L19.0407 12.3827C18.7887 12.0636 18.6098 11.5078 18.6098 11.0077C18.6098 10.5078 18.7888 9.95185 19.0407 9.63282L20.0718 8.48012C20.5402 7.95918 20.7744 7.69871 20.8084 7.37549C20.8423 7.05227 20.6674 6.74864 20.3175 6.14139Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M14.5195 11C14.5195 12.933 12.9525 14.5 11.0195 14.5C9.08653 14.5 7.51953 12.933 7.51953 11C7.51953 9.067 9.08653 7.5 11.0195 7.5C12.9525 7.5 14.5195 9.067 14.5195 11Z" stroke="#222222" stroke-width="1.5"/>
        </svg>
        <span>Настройки аккаунта</span>
      </div>

      <div class="sep"></div>

      <div class="items">
        <div class="item" v-for="(item, index) in items.slice(0,showItemsCnt)" :key="index" @click="select(item.id)">
          <div class="main">
            <img :src="item.image">
            <div class="info">
              <span class="type">{{item.type}}</span>
              <span class="name">{{item.title}}</span>
            </div>
          </div>
          <div class="selected_item" v-show="item.selected">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M8 12L10.5347 14.2812C10.9662 14.6696 11.6366 14.6101 11.993 14.1519L16 9M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#69BE15" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
      </div>

      <div class="show_all" @click="openAll()" :class="[{active : showItemsCnt > 2}]">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M7 10L12 14L17 10" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div class="sep"></div>

      <div class="nav_item" @click="toSettings('#legal_settings')">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M5.18007 15.2964C3.92249 16.0336 0.625213 17.5387 2.63348 19.4221C3.6145 20.3421 4.7071 21.0001 6.08077 21.0001H13.9192C15.2929 21.0001 16.3855 20.3421 17.3665 19.4221C19.3748 17.5387 16.0775 16.0336 14.8199 15.2964C11.8709 13.5679 8.12906 13.5679 5.18007 15.2964Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 7.00006C14 9.2092 12.2091 11.0001 10 11.0001C7.79086 11.0001 6 9.2092 6 7.00006C6 4.79092 7.79086 3.00006 10 3.00006C12.2091 3.00006 14 4.79092 14 7.00006Z" stroke="#222222" stroke-width="1.5"/>
          <path d="M19.5 4.00006V9.00006M22 6.50006L17 6.50006" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Добавить контрагента</span>
      </div>

      <div class="nav_item" @click="logout()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
          <path d="M7.75 1.00006L7.00462 1.25989C4.1035 2.27117 2.65294 2.77681 1.82647 3.93053C1 5.08424 1 6.6035 1 9.64202V12.3581C1 15.3966 1 16.9159 1.82647 18.0696C2.65294 19.2233 4.1035 19.729 7.00462 20.7402L7.75 21.0001" stroke="#222222" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M19 11.0001L7.75 11.0001M19 11.0001C19 10.222 16.7564 8.76843 16.1875 8.22229M19 11.0001C19 11.7781 16.7564 13.2317 16.1875 13.7778" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Выйти</span>
      </div>

    </div>

  </div>
</template>

<script>

import axios from "axios";

export default {
  name : "HeaderPersonal",
  data() {
    return{
      HeaderPersonalImgs : {
        'testAva': require('@/assets/test-ava.png'),
        'testAva2': require('@/assets/test-ava2.svg'),
      },
      showSelector : false,
      currentCounterparty: {id: 0, title: "Контрагент", image: require('@/assets/test-ava2.svg')},
      items : [],
      showItemsCnt: 2,
    }
  },
  methods : {
    openSelector : function() {
      if(!this.showSelector) {this.showSelector = true;} else {this.showSelector = false;}
    },
    openAll : function () {
      if(this.showItemsCnt == 2) {this.showItemsCnt = 99;} else {this.showItemsCnt = 2;}
    },
    select : async function(counterparty_id) {
      await axios.get(window.api_url + "counterparty/set?id="+counterparty_id+"&api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
      window.location.reload();
    },
    toSettings : function(hash) {
      this.$router.push({ name: "main", params: {tab: "settings"}, hash: hash });
    },
    logout: async function() {
      await axios.get(window.api_url + "auth/logout?api=y");
      this.$router.push({ name: "login"});
    },
  }
}
</script>

<style scoped>
.header-personal .selected{
  display: flex;
  gap: 10px;
  align-items: center;
  position: relative;
}

.header-personal .selected .image-empty {
  height: 44px;
  width: 44px;
  border-radius: 100px;
  border: 1px solid #DEDEDE;
  background: var(--BG, #F8F8F8);
  cursor: pointer;
}

.header-personal .selected .image{
  height: 44px;
  width: 44px;
  border-radius: 100px;
  border: 1px solid #DEDEDE;
  background: var(--BG, #F8F8F8);
  cursor: pointer;
}

.selected .name-dd {
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
}

.selected .name-dd span{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.selected svg.active{
  transform: rotate(180deg);
}



.header-personal .selector {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  box-shadow: 0px 6px 50px 0px rgba(0, 0, 0, 0.10);
  padding: 8px;
  position: absolute;
  top: 72px;
  right: 32px;
  width: 286px;
  z-index: 10;
}

.nav_item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  cursor: pointer;
}

.nav_item:hover {
  background: var(--BG, #F8F8F8);
  border-radius: 8px;
}

.nav_itemm:hover span{
  /*color: var(--Blue, #1B78BC);*/
}

.nav_item:hover svg path{
  /*stroke: var(--Blue, #1B78BC);*/
}

.nav_item span {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 134%;
}

.selector .sep {
  width: 100%;
  height: 1px;
  background: #EDEDED;
  margin: 12px 0px;
}

.items {
  max-height: 310px;
  overflow: auto;
}

.items .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
}

.items .item:hover {
  background: var(--BG, #F8F8F8);
  border-radius: 8px;
}

.items .item .main{
  display: flex;
  gap: 12px;
  align-items: center;
}

.items .item .main img{
  height: 44px;
  width: 44px;
  border-radius: 100px;
  border: 1px solid #DEDEDE;
  background: var(--BG, #F8F8F8);
  cursor: pointer;
}

.items .item .main .info{
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.items .item .main .info .type{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  cursor: pointer;
}

.items .item .main .info .name{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  cursor: pointer;
}



.show_all {
  border-radius: 8px;
  background: var(--BG, #F8F8F8);
  height: 36px;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
}

.show_all:hover {
  background: rgba(27, 120, 188, 0.10);
}

.show_all:hover svg path{
  stroke: #1B78BC;
}

.show_all.active {
  background: #1B78BC;
}

.show_all.active svg {
  transform: rotate(180deg);
}

.show_all.active svg path{
  stroke: #fff;
}

.show_all.active:hover {
  background: rgba(27, 120, 188, 0.10);
}

.show_all.active:hover svg path{
  stroke: #1B78BC;
}






/*MOBILE*/
@media (max-width: 1250px)
{

  .header-personal .selector .items {
    max-height: 300px;
    overflow: auto;
  }

  .header-personal .selector {
    right: 15px;
    top: 80px;
  }

  .header-personal .selected .image {
    width: 32px;
    height: 32px;
    margin-bottom: 3px;
  }

  .selected .name-dd {
    display: none;
  }

}
</style>